import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShower, faCartShopping, faGlassMartini, faFistRaised, faRedo, faComment, faEdit, faPlusSquare, faBookAtlas, faSchoolCircleCheck } from '@fortawesome/free-solid-svg-icons';
import './BPMForce.css';
import bpmforceimage from '../../assets/pageimages/BpmForce.webp';

function BPMForceHome() {
  const items = [
    { name: 'DMAIC', path: '/bpmforce-dmaic', icon: faSchoolCircleCheck },
    { name: 'RACI', path: '/bpmforce-raci', icon: faBookAtlas },
    { name: 'BPM Diary', path: '/bpmforce-diary', icon: faPlusSquare },
    { name: 'BPM Wiki', path: '/bpmforce-wiki', icon: faEdit },
    { name: 'Purple Power', path: '/purplepower-home', icon: faComment },
    { name: 'BPM Jobs', path: '/bpmjobs-home', icon: faRedo },
    { name: 'BPM Accounts', path: '/bpmforce-accounts', icon: faFistRaised },
    { name: 'VOC/Surveys', path: '/processifyd-voc-surveys', icon: faGlassMartini },
    { name: 'BPM Docs', path: '/processifyd-docs', icon: faCartShopping },
    { name: 'Business Pulse', path: '/bpmforce-business-pulse', icon: faShower },
    { name: 'BPM Flow', path: '/bpmforce-bpmflow', icon: faSchoolCircleCheck },
    { name: 'BPM Team', path: '/bpmforce-bpmteam', icon: faBookAtlas },
    { name: 'Integra', path: '/bpmforce-integra', icon: faPlusSquare },
    { name: 'Telemetry', path: '/bpmforce-telemetry', icon: faEdit },
    { name: 'Project Management', path: '/bpmforce-project-management', icon: faComment },
    { name: 'Risk', path: '/bpmforce-risk', icon: faRedo },
    { name: 'Masters', path: '/bpmforce-masters', icon: faFistRaised },
    { name: 'Users', path: '/bpmforce-users', icon: faGlassMartini }
  ];

  const iconMap = {
    faSchoolCircleCheck,
    faBookAtlas,
    faPlusSquare,
    faEdit,
    faComment,
    faRedo,
    faFistRaised,
    faGlassMartini,
    faCartShopping,
    faShower,
  };
  
  return (
    <MainLayout>
      <div className="mt-12 min-h-screen py-8 bg-gradient-to-r from-blue-400 via-green-500 to-yellow-200">
        <div className="p-4 rounded-lg flex flex-col sm:flex-row justify-around items-center space-y-4 sm:space-y-0 sm:space-x-8 ml-6 mr-6">
          <img id="bpmforce-id" src={bpmforceimage} alt="BPMForce Image" style={{height: "300px", width: "auto"}}/>
        </div>
        <h2 className='text-2xl font-bold text-red-500 text-center mb-2'>BPMForce</h2>
        <div className="bg-gray-200 mb-2 p-4 rounded-lg shadow-lg transition-transform transform hover:scale-105 flex flex-col sm:flex-row justify-around items-center space-y-4 sm:space-y-0 sm:space-x-8 ml-6 mr-6 mt-2">
          <div className="button-links flex align-middle justify-center">
            {items.map(item => (
                <div className="bottom-buttons-box" key={item.path}>
                  <Link to={item.path} className="top-button-link">
                    <FontAwesomeIcon icon={iconMap[item.icon]} className="bpmforce-bottomlink-style" />
                    {item.name}
                  </Link>
                </div>
              ))}          
          </div>
        </div>
      </div> 
    </MainLayout>
  );
}

export default BPMForceHome;
